import * as actions from './notas.action';
import inicialState from './notas.state';

const notasReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.ATUALIZAR_NOTA:
      return {
        ...state,
        nota: action.payload.nota,
      };
    case actions.SELECT_NOTA:
      return {
        ...state,
        selectNota: action.payload.selectNota,
      };
    default:
      return state;
  }
};

export default notasReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/notas/notas.reducer.js